import 'jquery-validation';
import 'jquery-validation/dist/additional-methods.js';
import 'jquery-mask-plugin';
import * as filestack from 'filestack-js';

$.validator.addMethod(
    'regex',
    function(value, element, regexp) {
        var re = new RegExp(regexp);
        return this.optional(element) || re.test(value);
    },
    "Please check the format of the information you've entered."
);

//Refresh token for login and registration forms
var rfSubmitCount = 0;
$('form.rform').on('submit',function (event) {
    //grechaptcha
    event.preventDefault();
    var that = this;//set that variable so it will be available in next function
    rfSubmitCount++;
    if (rfSubmitCount <=1 ) {//Prevent double-click
        if( $('#recaptchaResponse').length) {
            grecaptcha.ready(function () { 
                grecaptcha.execute('6Lerg-kUAAAAAOKHCBzpYMKugpr8WKG6fNPdhy6K', {action: 'register'}).then(function(token) {
                    var recaptchaResponse = document.getElementById('recaptchaResponse'); 
                    recaptchaResponse.value = token;
                    
                    $(that).off("submit"); // to guarantee the function won't be invoked
                    that.submit();
                });
            });
        }
    }
});

/// https://github.com/rstaib/jquery-steps/wiki/Settings
var wizardSubmitCount = 0;
$('#wizard').steps({
    headerTag: 'h2',
    bodyTag: 'section',
    actionContainerTag: 'nav',
    transitionEffect: 'slideLeft',
    autoFocus: true,
    // enableFinishButton: false,
    // startIndex: 3,
    enableAllSteps: false,
    titleTemplate: '#title#',
    transitionEffect: 'fade',
    labels: {
        cancel: 'Cancel',
        current: 'Current:',
        pagination: 'Pagination',
        finish: 'Save',
        next: 'Next',
        previous: ' ',
        loading: 'Loading ...'
    },

    onStepChanging: function(event, currentIndex, newIndex) {
        // Close any alerts on the page
        $('.alert').slideUp();

        // Always allow going backward even if the current step contains invalid fields!
        if (currentIndex > newIndex) {
            return true;
        }

        var form = $(this);

        // Clean up if user went backward before
        if (currentIndex < newIndex) {
            // To remove error styles
            $('.body:eq(' + newIndex + ') label.error', form).remove();
            $('.body:eq(' + newIndex + ') .error', form).removeClass('error');
        }

        form.validate({
            ignore: ':disabled,:hidden',
            focusInvalid: false,
            invalidHandler: function(form, validator) {
                if (!validator.numberOfInvalids()) return;
                $('html, body').animate(
                    {
                        scrollTop: $(validator.errorList[0].element).offset().top - 120
                    },
                    'slow'
                );
            },
            rules: {
                // "phone_number": {
                //     regex: "[0-9]{3}-[0-9]{3}-[0-9]{4}",
                // },
                zip: {
                    regex: '^[0-9]{5}(?:-[0-9]{4})?$'
                },
                display_contact_phone: {
                    require_from_group: [1, '.require-contact']
                },
                display_contact_email: {
                    require_from_group: [1, '.require-contact']
                }
            },
            groups: {
                displayContact: 'display_contact_phone display_contact_email'
            },
            messages: {
                open_to_public: 'You must choose a privacy option to continue.',
                location_type: 'You must choose a group type option to continue.',
                time_starts: 'Start time is required.',
                time_ends: 'End time is required.',
                preferred_contact_method: 'Choose a preferred contact method to continue.',
                group_starts: 'Please choose a date after today.',
                group_ends: 'Please choose a date after the group start date.',
                registration_starts: 'Please choose a registration start date.',
                registration_ends: 'Please choose a date after the registration start date.',
                phone_number: 'Please enter your phone number.',
                display_contact_phone: 'Please choose at least one contact method.',
                display_contact_email: 'Please choose at least one contact method.'
            },
            errorPlacement: function(label, element) {
                if (element.attr('name') === 'open_to_public') {
                    label.insertAfter('.privacy-setting-label');
                } else if (element.attr('name') === 'location_type') {
                    label.insertAfter('.group-type-label');
                } else if (element.attr('name') === 'time_starts' || element.attr('name') === 'time_ends') {
                    label.insertAfter('.meeting-time-label');
                } else if (element.attr('name') === 'visible_until' || element.attr('name') === 'time_ends') {
                    label.insertAfter('.hide-group-label');
                } else if (element.attr('name') === 'preferred_contact_method') {
                    label.insertAfter('.preferred-contact-label');
                } else if (element.attr('name') === 'max_num_of_seats') {
                    label.insertAfter('.group-capacity-label');
                    // } else if (element.attr( "name") === "name_of_place") {
                    //     label.insertAfter('.meeting-address-label');
                } else if (element.attr('name') === 'timezone') {
                    label.insertAfter('.timezone-label');
                } else if (element.attr('name') === 'display_contact_phone') {
                    label.insertAfter('.display-contact-label');
                } else if (element.attr('name') === 'display_contact_email') {
                    label.insertAfter('.display-contact-label');
                } else {
                    label.insertAfter(element); // standard behaviour
                }
            },
            showErrors: function(errorMap, errorList) {
                var errors = this.numberOfInvalids();
                if (errors) {
                    var message = 'You missed some required fields. They have been highlighted below.';
                    if ($('#summary').is(':hidden')) {
                        $('#summary').show();
                    }
                    $('#summary').html(message);
                } else {
                    $('#summary').hide();
                }
                this.defaultShowErrors();
            }
        });

        // form.validate().settings.ignore = ':disabled,:hidden';
        return form.valid();
    },

    onStepChanged: function(event, currentIndex, priorIndex) {
        $('html, body').animate({ scrollTop: 0 });        
    },

    onFinishing: function(event, currentIndex) {

        var form = $(this);
        form.validate().settings.ignore = ':disabled,:hidden';
        return form.valid();

    },

    onFinished: function(event, currentIndex) {
        wizardSubmitCount++;
        if (wizardSubmitCount <=1 ) {//Prevent double-click
            if( $('#recaptchaResponse').length) {
                grecaptcha.ready(function () { 
                    grecaptcha.execute('6Lerg-kUAAAAAOKHCBzpYMKugpr8WKG6fNPdhy6K', {action: 'register'}).then(function(token) {
                        var recaptchaResponse = document.getElementById('recaptchaResponse'); 
                        recaptchaResponse.value = token;
                        
                        document.getElementById('wizard').submit();
                    });
                });
            } else {
                var form = $(this);
                form.submit();
            }
        }
        
    }
});

$.fn.steps.setStep = function(step) {
    var currentIndex = $(this).steps('getCurrentIndex');
    for (var i = 0; i < Math.abs(step - currentIndex); i++) {
        if (step > currentIndex) {
            $(this).steps('next');
        } else {
            $(this).steps('previous');
        }
    }
};

$('.to-first-step').click(function() {
    $('#wizard').steps('setStep', 0);
    $(this).preventDefault();
});

$('.close-alert').click(function() {
    $(this)
        .parent()
        .slideUp();
});

// https://thdoan.github.io/pretty-dropdowns
const dropdown = $('select:not(.no-pretty)').prettyDropdown({
    height: 42,
    classic: true,
    width: '100%'
});

/// Change values in the what you want public section based on inputs
$(function() {
    var audience = $('#primary_audience option:selected').text();
    $('#chosen-audience').text(audience);
    $('select#primary_audience').change(function() {
        $('#chosen-audience').text($(this).val());
    });
    var age = $('#age_range option:selected').text();
    $('#chosen-age').text(age);
    $('select#age_range').change(function() {
        $('#chosen-age').text($(this).val());
    });
    var trained = $('#year_trained').val();
    if (typeof trained !== 'undefined' && trained.length != 0) {
        $('#chosen-year').text(trained);
        $('#always-show').show();
    }
    $('#year_trained').change(function() {
        $('#chosen-year').text($(this).val());
        $('#always-show').show();
    });
});

/// Welcome message at first visit

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
var dynamicContent = getParameterByName('created');
if (dynamicContent == '1') {
    $('#modal-welcome').modal();
}

// π ----
// :: PASSWORDS ---------------------------::
// ____

/// Check if passwords match before submit and display notice if not
$('#pw2').focusout(() => {
    const pass = $('#pw1').val();
    const pass2 = $('#pw2').val();
    if (pass != pass2) {
        $('#password-notice').show();
    }
    if (pass == pass2) {
        $('#password-notice').hide();
    }
});

/* :: Password Strength
{+} ---------------------------------- */
$('#pw1').focusout(() => {
    const pass = $('#pw1').val();
    const strengthChar = $('#password-strength').find('[data-pass-characters]');
    const strengthUpper = $('#password-strength').find('[data-pass-uppercase]');
    const strengthLower = $('#password-strength').find('[data-pass-lowercase]');
    const strengthNumber = $('#password-strength').find('[data-pass-number]');
    const strengthSpecial = $('#password-strength').find('[data-pass-special]');
    let error = null;

    // :: Character Length ------------ //
    if (pass.length < 8) {
        error = true;
        strengthChar.show();
    } else {
        strengthChar.hide();
    }

    // :: Upper ------------ //
    if (pass.match(/([A-Z])/)) {
        strengthUpper.hide();
    } else {
        error = true;
        strengthUpper.show();
    }

    // :: Lower ------------ //
    if (pass.match(/([a-z])/)) {
        strengthLower.hide();
    } else {
        error = true;
        strengthLower.show();
    }

    // :: Number ------------ //
    if (pass.match(/([0-9])/)) {
        strengthNumber.hide();
    } else {
        error = true;
        strengthNumber.show();
    }

    // :: Special Character ------------ //
    if (pass.match(/([!,%,&,@,#,$,^,*,?,_,~])/)) {
        strengthSpecial.hide();
    } else {
        error = true;
        strengthSpecial.show();
    }

    // :: Toggle Errors ------------ //
    if (error) {
        $('#password-strength').show();
        $('#form-submit').prop('disabled', true);
    } else {
        $('#password-strength').hide();
        $('#form-submit').prop('disabled', false);
    }
});

/// Phone number masking http://igorescobar.github.io/jQuery-Mask-Plugin/docs.html
$(document).ready(function() {
    $('#phone_number').mask('000-000-0000');
});

/// Alert if someone attempts to leave a form after making changes  https://github.com/codedance/jquery.AreYouSure
$('form.dirty-check').areYouSure();

// π ----
// :: GROUP AUDIENCE ---------------------------::
// ____
audienceInit(
    document.getElementById('primary_audience'),
    document.getElementById('age_range_wrapper'),
    document.getElementById('age_range')
);
audienceInit(
    document.getElementById('secondary_audience'),
    document.getElementById('age_range_wrapper02'),
    document.getElementById('secondary_age_range')
);

function audienceInit(audience, ageRange, ageInput) {
    if (audience && ageRange) {
        audienceChange(audience, ageRange, ageInput);
    }
}

function audienceChange(audience, ageRange, ageInput) {
    // :: Initial Check ------------ //
    toggleAgeRange(audience, ageRange, ageInput);

    // :: Check on field change ------------ //
    audience.onchange = () => {
        toggleAgeRange(audience, ageRange, ageInput);
    };
}

function toggleAgeRange(audience, ageRange, ageInput) {
    const audienceVal = audience.value;
    if (ageRange.classList.contains('has-all_ages')) {
        // This code assumes All Ages is the last option
        if (audienceVal === 'General Audience') {
            /* ageInput.selectedIndex = ageInput.options.length - 1;
            jQuery(ageRange)
                .find('li')
                .removeClass('selected')
                .last()
                .addClass('selected'); */
        }
    } else {
        // Code that existed before the conditional was added
        if (audienceVal === 'General Audience') {
            ageRange.classList.add('hidden');
            ageInput.selectedIndex = '-1';
        } else {
            ageRange.classList.remove('hidden');
        }
    }
}

// π ----
// :: TIME FIELDS ---------------------------::
// ____
function updateTime() {
    const hourStart = document.getElementById('start-time-hour').value;
    const minuteStart = document.getElementById('start-time-minutes').value;
    const amPmStart = document.getElementById('start-time-am-pm').value;
    const hourEnd = document.getElementById('end-time-hour').value;
    const minuteEnd = document.getElementById('end-time-minutes').value;
    const amPmEnd = document.getElementById('end-time-am-pm').value;
    const timeError = document.getElementById('time-error');

    const timeStartPoint = getTimePoint(parseInt(hourStart), parseInt(minuteStart), amPmStart);
    const timeEndPoint = getTimePoint(parseInt(hourEnd), parseInt(minuteEnd), amPmEnd);
    const timeStart = `${hourStart}:${minuteStart} ${amPmStart}`;
    const timeEnd = `${hourEnd}:${minuteEnd} ${amPmEnd}`;

    // :: Check Start & End Time ------------ //
    if (parseInt(timeStartPoint) < parseInt(timeEndPoint)) {
        timeError.classList.add('hidden');
        $('[data-form-submit]').prop('disabled', false);
    } else {
        timeError.classList.remove('hidden');
        $('[data-form-submit]').prop('disabled', true);
    }

    document.getElementById('time_starts').value = timeStart;
    document.getElementById('time_ends').value = timeEnd;
}

function getTimePoint(hour, minute, amPm) {
    if (amPm === 'PM' && hour != 12) {
        return `${hour + 12}.${minute}`;
    } else if (hour === 12 && amPm === 'AM') {
        return `0.${minute}`;
    } else {
        return `${hour}.${minute}`;
    }
}

const timeFields = document.querySelectorAll('[data-time-field]');

timeFields.forEach(function(field) {
    field.onchange = () => {
        updateTime();
    };
});

/* :: Change Time
{+} ---------------------------------- */
const timeChange = document.getElementById('time-change');

if (timeChange) {
    timeChange.onclick = ev => {
        ev.preventDefault();
        timeChange.classList.add('hidden');
        document.getElementById('time-selection').classList.remove('hidden');
        document.getElementById('time-selection').classList.add('block');
    };
}

// π ----
// :: LEADER TRAINING ---------------------------::
// ____
function leaderTraining() {
    const yearAttended = document.getElementById('year-attended');

    $('input:radio[name="leader-training"]').change(function() {
        if ($(this).val() == 'yes') {
            yearAttended.classList.remove('hidden');
            yearAttended.required = true;
        } else {
            yearAttended.classList.add('hidden');
            yearAttended.required = false;
        }
    });
}

if (document.getElementById('leader-training-select')) {
    leaderTraining();
}

// シ ----
// :: FILESTACK AVATAR ---------------------------::
// ____
function uploadAvatar() {
    const apikey = 'A5ddCuFXcRFeGmOekWWi6z';
    const client = filestack.init(apikey);
    const container = document.getElementById('avatar-upload');
    const change = document.getElementById('avatar-change');
    const change_notice = document.getElementById('avatar-change-notice');

    const picker = client.picker({
        container,
        displayMode: 'dropPane',
        dropPane: {
            customText: 'Drag & Drop or Click to Upload',
            onSuccess(avatar) {
                const handle = avatar[0].handle;
                const preview = document.getElementById('avatar-content');
                const inputField = document.getElementById('profile_photo_handle');

                container.classList.add('hidden');
                change.classList.remove('hidden');
                change.classList.add('block');
                change_notice.classList.remove('hidden');
                change_notice.classList.add('block');
                preview.innerHTML = setAvatarPreview(handle);
                inputField.value = handle;
            }
        }
    });

    picker.open();

    change.onclick = ev => {
        ev.preventDefault();
        container.classList.remove('hidden');
        change.classList.add('hidden');
        change.classList.remove('block');
        change_notice.classList.add('hidden');
        change_notice.classList.remove('block');
    };
}

function setAvatarPreview(handle) {
    return `<div class="w-40 h-40 rounded overflow-hidden mx-auto my-6"><img class="w-full h-full object-cover" src="https://cdn.filestackcontent.com/${handle}"></div>`;
}

if (document.getElementById('avatar-upload')) {
    uploadAvatar();
}
